import { Typography } from '@navi/web-ui/lib/primitives';
import React, { useEffect } from 'react';
import StepsButton from './StepsButton';
import styles from './index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInputValidations } from '../../actions/FieldAllocationAction';
import { RootState } from '@cp/src/store';
import { CircularLoaderIcon } from '@navi/web-ui/lib/icons';
import { ValidationData } from '../../interface';

interface ValidationStepProps {
  handleCloseModal: () => void;
  handleNextStep: () => void;
}

const ValidationStep: React.FC<ValidationStepProps> = ({ handleCloseModal, handleNextStep }) => {
  const dispatch = useDispatch();
  const inputValidations = useSelector(
    (state: RootState) => state.fieldAllocation?.inputValidations
  );
  const { data = [], loading } = inputValidations || {};

  useEffect(() => {
    dispatch(fetchInputValidations());
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[130px]">
        <CircularLoaderIcon size="md" />
      </div>
    );
  }

  return (
    <>
      <div className={styles.validationItems}>
        {data?.map((item: ValidationData) => (
          <div className={styles.validationItem} key={item.key}>
            <Typography variant="h4" color="var(--navi-color-gray-c2)">
              {item.name}
            </Typography>
            <Typography variant="h4" color={item?.color}>
              {item.comments}
            </Typography>
          </div>
        ))}
      </div>
      <StepsButton
        onCancel={handleCloseModal}
        onAction={handleNextStep}
        actionText="Next (1/2)"
        disabled={!data?.length}
      />
    </>
  );
};

export default ValidationStep;
